import { Injectable } from '@angular/core';
import { PageNotFoundEnum } from "@shared/enums/page-not-found.enum";

@Injectable()
export class UrlBuilderService {

  public getCreatedCustomUrl(url: string, queryParam: string, paramValue: number | undefined): string | undefined {
    if (!url || !queryParam || !paramValue) return undefined;

    return `${url}?${queryParam}=${paramValue}`;
  }
}
